<div echarts #SankeyChart [options]="chartOption" [merge]="mergeOptions" class="sankey-chart"></div>